var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70021 18.3C10.0902 17.91 10.0902 17.28 9.70021 16.89L5.83021 13H21.0002C21.5502 13 22.0002 12.55 22.0002 12C22.0002 11.45 21.5502 11 21.0002 11H5.83021L9.71021 7.11998C10.1002 6.72998 10.1002 6.09998 9.71021 5.70998C9.32021 5.31998 8.69021 5.31998 8.30021 5.70998L2.70021 11.3C2.31021 11.69 2.31021 12.32 2.70021 12.71L8.29021 18.3C8.68021 18.68 9.32021 18.68 9.70021 18.3Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.2dd24fc8.svg";
export { ForwardRef as ReactComponent };